import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useRouteMatch } from 'react-router-dom';
import { LabelAndValue } from '../../../../../global/components/data-display/label-value';
import { getFormattedDate } from '../../../../../global/helpers/date-helpers';
import { ArcRoutes } from '../../../constants/routes';
import { CompensationProps } from '../../../models/arc-epi-props';
import { Employment, ScheduledHours } from '../../employment/employment-model';
import { getCurrentEmploymentItem } from '../../employment/employment-selectors';
import { buttonStyles } from '../../../../../global/constants/theme/styles/components/buttonstyles';
import { ButtonWrapper } from '../../../../../global/components/layout/button-wrapper';
import { TcsmStates } from '../../../../../root/tcsm-model';

interface Props {
    employmentData: Employment;
    disabled: boolean;
}
export function ScheduledHoursInfo(props: Props) {
    const { employmentData, disabled } = props;

    const epiProps = useSelector<TcsmStates, CompensationProps>(state => state?.epiProps?.compensationSettingsState?.epiContent);
    const routeMatch = useRouteMatch();

    const currentScheduledHours = getCurrentEmploymentItem(employmentData?.scheduled_hours) as ScheduledHours;
    const buttonClasses = buttonStyles();
    return (
        <>
            <ButtonWrapper>
                <Link to={`${routeMatch.path}${ArcRoutes.ScheduledHours}`} className={`${buttonClasses.secondaryButton} ${disabled ? 'disabled' : ''}`}>{epiProps.updateScheduledHoursText}</Link>
            </ButtonWrapper>

            <LabelAndValue label={epiProps.currentScheduledHoursLabel} value={currentScheduledHours?.hours?.toString()} />
            <LabelAndValue label={epiProps.scheduledHoursStartDateLabel} value={getFormattedDate(currentScheduledHours?.start_date)} />

            <Link to={`${routeMatch.path}${ArcRoutes.ScheduledHoursHistory}`}>{epiProps.viewScheduledHoursHistoryText}</Link>
        </>
    );
}